var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextElement = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const html_react_parser_1 = __importStar(require("html-react-parser"));
const IMAGE_ID_ATTRIBUTE_IDENTIFIER = 'data-image-id';
const LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER = 'data-item-id';
const isLinkedItem = (domNode) => {
    var _a;
    return domNode.name === 'object' &&
        ((_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a.type) === 'application/kenticocloud';
};
const isImage = (domNode) => {
    var _a;
    return domNode.name === 'figure' &&
        typeof ((_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a[IMAGE_ID_ATTRIBUTE_IDENTIFIER]) !== 'undefined';
};
const isLink = (domNode) => {
    var _a;
    return domNode.name === 'a' &&
        typeof ((_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a[LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER]) !== 'undefined';
};
const replaceNode = (domNode, linkedItems, resolveLinkedItem, images, resolveImage, links, resolveLink, resolveDomNode) => {
    var _a, _b, _c;
    if (resolveLinkedItem && linkedItems) {
        if (isLinkedItem(domNode)) {
            const codeName = (_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a['data-codename'];
            const linkedItem = linkedItems.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.system) === null || _a === void 0 ? void 0 : _a.codename) === codeName; });
            return resolveLinkedItem(linkedItem, domNode);
        }
    }
    if (resolveImage && images) {
        if (isImage(domNode)) {
            const imageId = (_b = domNode.attribs) === null || _b === void 0 ? void 0 : _b[IMAGE_ID_ATTRIBUTE_IDENTIFIER];
            const image = images.find(image => (image === null || image === void 0 ? void 0 : image.image_id) === imageId);
            return resolveImage(image);
        }
    }
    if (resolveLink && links) {
        if (isLink(domNode)) {
            const linkId = (_c = domNode.attribs) === null || _c === void 0 ? void 0 : _c[LINKED_ITEM_ID_ATTRIBUTE_IDENTIFIER];
            const link = links.find(links => (links === null || links === void 0 ? void 0 : links.link_id) === linkId);
            return resolveLink(link, domNode);
        }
    }
    if (resolveDomNode) {
        return resolveDomNode(domNode, html_react_parser_1.domToReact);
    }
};
const RichTextElement = ({ value, linkedItems, resolveLinkedItem, images, resolveImage, links, resolveLink, resolveDomNode, }) => {
    const result = (0, html_react_parser_1.default)(value, {
        replace: (domNode) => replaceNode(domNode, linkedItems, resolveLinkedItem, images, resolveImage, links, resolveLink, resolveDomNode),
    });
    if (result) {
        return react_1.default.createElement(react_1.default.Fragment, null, result);
    }
    return result;
};
exports.RichTextElement = RichTextElement;
//# sourceMappingURL=index.js.map